// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementGetChangelogsResult = objectOf({
  changelog_items: arrayOf(
    objectOf({
      date: number,
      email: string,
      diffs: arrayOf(
        objectOf({
          field_name: string,
          before: anyOf(string, nullOrUndefined),
          after: string,
          tag: string,
        })
      ),
    })
  ),
});
